import { AuthorContent } from '@silvertours/back-domain-page';
import {
  Wrapper,
  ImageWrapper,
  StyledImage,
  AuthorWrapper,
  AuthorText,
  AuthorTitle,
  AuthorName,
} from './Author.styles';

type AuthorProps = AuthorContent & {
  title: string;
};

const Author = ({ name, text, image, title }: AuthorProps) => (
  <Wrapper id="author">
    <ImageWrapper>
      {image && <StyledImage src={image.src} alt="" width="128" height="128" />}
    </ImageWrapper>
    <AuthorWrapper>
      <AuthorTitle>{title}</AuthorTitle>
      <AuthorName>{name}</AuthorName>
      <AuthorText>{text}</AuthorText>
    </AuthorWrapper>
  </Wrapper>
);
export { Author };
